export default "__VITE_ASSET__CJhc2SAh__"